import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ExamLocationService } from '../../../services';

@Component({
  selector: 'app-exam-location-table-filter',
  templateUrl:
    './exam-location-table-filter.component.html',
  styleUrls: [
    './exam-location-table-filter.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ExamLocationTableFilterComponent
  implements OnInit, OnDestroy
{
  searchControl!: UntypedFormControl;
  private searchSubscription!: Subscription;
  private timeToWaitBeforeUpdateMs = 250;

  constructor(private service: ExamLocationService) {}

  ngOnInit(): void {
    this.searchControl = new UntypedFormControl(
      this.service.listState.filter.search
    );
    this.searchSubscription =
      this.searchControl.valueChanges
        .pipe(debounceTime(this.timeToWaitBeforeUpdateMs))
        .subscribe((value) => {
          this.service.listState.filter.search = value;
          this.reload();
        });
  }

  reload(): void {
    this.service.loadList();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
